import ScalarMenuWorkspacePicker_vue_vue_type_script_setup_true_lang_default from "./ScalarMenuWorkspacePicker.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarMenu/ScalarMenuWorkspacePicker.vue
var ScalarMenuWorkspacePicker_default = ScalarMenuWorkspacePicker_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenuWorkspacePicker_default as default };

//# sourceMappingURL=ScalarMenuWorkspacePicker.vue.js.map